import { useEffect, useState } from "react";
import { Check, Plus, X } from "react-feather";
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';
import timeGridPlugin from '@fullcalendar/timegrid';
import { getAllBlockFlightTime, getAllFlights } from "../../api/flightsAPI";
import { useQuery } from "@tanstack/react-query";
import { useAuthStore } from "../../store/authStore";
import FlightInfoModal from "./flightModal/flightInfoModal";
import useFlightStore from "../../store/flightStore";
import BookFlightModal from "./flightModal/bookFlightModal";
import { ToastContainer } from "react-toastify";
import BlockFlightTimeInfoModal from "./flightModal/blockFlightTimeInfo";

const AllFlightPage = () => {
    const [flightType, setFlightType] = useState("upcoming");
    const [clickEventFlightId, setClickEventFlightId] = useState("");
    const { token } = useAuthStore((state) => state);
    const [dateClickStartTime, setDateClickStartTime] = useState("");
    const [dateClickEndTime, setDateClickEndTime] = useState("");
    const [clickedBlockFlightTimeId, setClickedBlockFlightTimeId] = useState("")
    const { showFlightModal, setShowFlightModal, setShowBookFlightModal, showBookFlightModal, showBlockFlightTimeModal, setShowBlockFlightTimeModal } = useFlightStore((state) => state);
    // get flights from api
    const { isLoading, data: allFlightsData, error, refetch } = useQuery({
        queryFn: getAllFlights,
        queryKey: ["getFlights", token, flightType],
        refetchOnWindowFocus: false,
    });

    const allFlightsEvents = allFlightsData?.data?.data?.length > 0 ? allFlightsData?.data?.data?.map((flight) => {
        return {
            id: flight._id,
            title: flight?.flightReason,
            color: flight.approvalStatus === "approved" ? "green" : flight.approvalStatus === "pending" ? "orange" : flight.approvalStatus === "rejected" ? "red" : "grey",
            start: flight?.flightStartTime,
            end: flight?.flightEndTime,
            allDay: false,
        };
    }) : [];

    return (
        <div className="p-4">
            <ToastContainer />
            <div className="flex justify-between items-center">
                <h1 className="w-full h-full flex">
                    <span className="text-4xl">My Flights</span>
                    <select onChange={(e) => { setFlightType(e.target.value) }} className="text-xl p-2 bg-blue-100 rounded-xl ml-4">
                        <option value="upcoming">Upcoming</option>
                        <option value="past">Past</option>
                        <option value="approved">Approved</option>
                    </select>
                </h1>

                {/* <div className="flex">

                    <button
                        // onClick={() => setAdding(true)}
                        className="bg-tblu flex text-white whitespace-nowrap p-4 text-md rounded-xl"
                    >
                        <Plus /> &ensp; Add Flight
                    </button>

                </div> */}
            </div>
            <br />
            <hr />
            <br />

            <div className="w-full">
                <FullCalendar
                    plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
                    initialView="timeGridWeek"//timeGridWeek,dayGridMonth
                    headerToolbar={{
                        left: 'prev,next today',
                        center: 'title',
                        right: 'dayGridMonth,timeGridWeek,timeGridDay',
                        start: 'title',
                        end: 'prev,next',
                    }}
                    allDaySlot={false}
                    dayHeaderClassNames={`text-center font-bold text-md capitalize border-none`}
                    views={{
                        timeGridWeek: {
                            type: 'timeGridWeek',
                            duration: { days: 6 },
                            buttonText: 'Week',
                        },
                        // dayGridMonth: {
                        //     type: 'dayGridMonth',
                        //     duration: { days: 6 },
                        //     buttonText: 'Month',
                        // },
                        // timeGridDay: {
                        //     type: 'timeGridDay',
                        //     duration: { days: 1 },
                        //     buttonText: 'Day',
                        // },
                    }}


                    selectable={true}
                    select={(info) => {
                        if (info.start < Date.now()) {
                            return
                        }
                        setShowBookFlightModal(true)
                        setDateClickStartTime(info.startStr);
                        setDateClickEndTime(info.endStr);
                    }}
                    displayEventTime={true}
                    eventClassNames={`cursor-pointer font-bold text-md capitalize`}
                    eventClick={(info) => {
                        if (info.event._def.groupId === "blockEvents") {
                            setClickedBlockFlightTimeId(info.event._def.publicId)
                            setShowBlockFlightTimeModal(true)
                        } else {
                            setShowFlightModal(true);
                            setClickEventFlightId(info.event._def.publicId);
                        }
                    }}
                    // businessHours={{
                    //     daysOfWeek: [1, 2, 3, 4, 5],
                    //     startTime: '08:00',
                    //     endTime: '17:00',

                    // }}
                    // eventConstraint={{
                    //     startTime: 1684578697756,
                    //     endTime: 1684678697756
                    // }}


                    events={allFlightsEvents}

                />
            </div>
            {showFlightModal && <FlightInfoModal flightId={clickEventFlightId} />}
            {showBookFlightModal && <BookFlightModal startTime={dateClickStartTime} endTime={dateClickEndTime} />}
            {showBlockFlightTimeModal && <BlockFlightTimeInfoModal id={clickedBlockFlightTimeId} />}
        </div>

    );
}
export default AllFlightPage;